import { Compass } from "lucide-react";

export function Brand({ compact = false }: { compact?: boolean }) {
  return <div className="brand" aria-label="Rihvo.fun home">
    <span className="brand-mark"><Compass size={compact ? 19 : 22} strokeWidth={1.8} /></span>
    {!compact && <span>Rihvo<span>.fun</span></span>}
  </div>;
}
